import { render, staticRenderFns } from "./EntityDetailSkeleton.vue?vue&type=template&id=38945f8c&scoped=true"
import script from "./EntityDetailSkeleton.vue?vue&type=script&lang=js"
export * from "./EntityDetailSkeleton.vue?vue&type=script&lang=js"
import style0 from "./EntityDetailSkeleton.vue?vue&type=style&index=0&id=38945f8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38945f8c",
  null
  
)

export default component.exports